import React from 'react';
import { useParams } from 'react-router-dom';

function CarPage() {
  // `useParams` გამოიყენება პარამეტრების მისაღებად URL-დან
  const { model } = useParams();

  // მოდელების მონაცემები, რომლებიც გამოიყენება `CarPage`-ში
  const data = [
    { id: 1, name: 'Toyota', description: 'A reliable car from Japan' },
    { id: 2, name: 'BMW', description: 'A luxury car from Germany' },
    { id: 3, name: 'Audi', description: 'High-performance car from Germany' },
    { id: 4, name: 'Mercedes', description: 'A premium car from Germany' },
  ];

  // მოცემული მოდელი (მათემატიკური ნომერი) ჩვენება
  const car = data.find((car) => car.name === model);

  return (
    <div>
        <br></br>
        <br></br>
        <br></br>
        <br></br>
        <br></br>
        <br></br> <br></br>
        <br></br>

      <h1>მოდელის ინფორმაცია: {car?.name}</h1>
      <p>{car?.description}</p>
      {/* აქ შეგიძლიათ დაამატოთ მანქანის სურათები, ღილაკები ან სხვა დეტალები */}
      {car ? (
        <img src={`/${car.name.toLowerCase()}.jpg`} alt={car.name} />
      ) : (
        <p>მანქანა არ მოიძებნა</p>
      )}
    </div>
  );
}

export default CarPage;
